import { UiConfig } from '@calendly/ui/config';
import { cx } from '@linaria/core';
import { AvailabilityCalendar, CALENDAR_VARIANT_EDITOR_PREVIEW } from 'features/event_type_editor';
import { EDITOR_PREVIEW_MODES, useEditorPreviewActions, useEditorPreviewState } from './editor_preview_context';
const CALENDAR_PREVIEW_BREAKPOINTS = {
  small: 500,
  medium: 800,
  large: 1000,
  xLarge: 1500
};

// Large layout supplies column height via stickyPreviewColumnCss; modal and
// small layout rely on natural height and max-height: inherit here instead.
const previewPanelCss = "pgff96f";
const placeholderCss = "p1axt3o3";

/* Figma Main content inset: spacing1_5x on top / left / right */
const calendarPreviewCss = "c84hz85";
export const PreviewPanel = ({
  className
}) => {
  const {
    mode,
    calendarFormPath
  } = useEditorPreviewState();
  const {
    showDefaultPreview
  } = useEditorPreviewActions();
  if (mode === EDITOR_PREVIEW_MODES.calendar && calendarFormPath) {
    return <div className={cx(previewPanelCss, className)} data-testid="editor-preview-panel" data-preview-mode="calendar" aria-label="Availability calendar preview">
        <UiConfig breakpoints={CALENDAR_PREVIEW_BREAKPOINTS}>
          <div className={calendarPreviewCss}>
            <AvailabilityCalendar formPath={calendarFormPath} onClose={showDefaultPreview} variant={CALENDAR_VARIANT_EDITOR_PREVIEW} />
          </div>
        </UiConfig>
      </div>;
  }
  return <div className={cx(previewPanelCss, className)} data-testid="editor-preview-panel" data-preview-mode="default" aria-label="Event type preview">
      <div className={placeholderCss}>
        Preview
      </div>
    </div>;
};

require("./preview_panel.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./preview_panel.js");